import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const ippcAcronymsSchema: CollectionCreateSchema = {
  name: CollectionName.IppcAcronyms,
  fields: [
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
